import { CommonsSessionStorageService } from 'ib-web-commons/dist/utils';

import angular from 'angular';
import { DatalayerBKIConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/constants/ib-datalayer-bki-constants';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { AncillariesService } from '../../ib-web-ancillaries/ib-web-ancillaries-service';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { ModalServiceAncillaries } from '../../ib-modal/services/ib-modal-ancillaries-service';
import { NewSeatsMapService } from '../service/ib-new-seat-map-service';
import { NewSeatsMapTransformer } from '../transformer/ib-new-seat-map-transformer';
import { Subscription } from 'rxjs';
const controllerInfo = {
    module: 'ib-new-seat-map-module',
    inject: ['$rootScope', '$uibModalInstance', '$window', 'AncillariesService', 'NewSeatsMapService', 'object', '$scope', '$timeout', 'AncillariesConstants', 'CurrencyService', 'localStorageService', 'AncillariesUtilsService', '$location', 'ModalServiceAncillaries', 'NewSeatsMapTransformer', 'DatalayerUtilsService', 'CommonsConstants', 'DatalayerConstants', 'DatalayerUtils', 'DatalayerBKIConstants', 'CommonsSessionStorageService', 'CommonsUtilService', 'IbCModalService', 'CommonsAncillariesService'],
    required: []
};

export class NewSeatsMapController implements angular.IController {
    public model;
    public isLoading = true;
    public isLoadingConfirmSeats = false;
    public currency: any;
    public updateData;
    public currentSeatmapData: any = {};
    public deleteCurrentSeatmapData: any = [];
    public backPassengerUpdate = false;
    public showModalAvios: boolean = false;
    public flightAviosInfo: boolean;
    public reductedMovilityBanner: boolean;
    public showTour: boolean = false;
    public isMobile: boolean = false;
    public seatmapSegment: any;
    public flowName: string;
    public aircraftToShow;
    public isSeat3dViewAvailable: boolean = false;
    public seatViewInfo: any;
    public isOldConfig: any;
    isSelectedSegmentFromMobileSummary: boolean = false;
    private totalSeatsPriceSubscription: Subscription | undefined;
    private seatAviosSubscription: Subscription | undefined;
    private seatAvios: any[] = [];
    private totalSeatsPrice: any;
    private isAnySeatUpdated: boolean = false;
    availableSegments: string[];
    private singleSegment: boolean;
    isLastSegment: boolean = false;
    nextSegment: any;


    constructor (
        private $rootScope: CommonsRootScope,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $window: ng.IWindowService,
        private AncillariesService: AncillariesService,
        private NewSeatsMapService: NewSeatsMapService,
        private object: any,
        private $scope: angular.IScope,
        private $timeout: ng.ITimeoutService,
        private AncillariesConstants: AncillariesConstant,
        private CurrencyService: CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private $location: ng.ILocationService,
        private ModalServiceAncillaries: ModalServiceAncillaries,
        private SeatsMapTransformer: NewSeatsMapTransformer,
        private DatalayerUtilsService: DatalayerUtilsService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private DatalayerUtils: DatalayerUtils,
        private DatalayerBKIConstants: DatalayerBKIConstantsType,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private CommonsUtilService: CommonsUtilService,
        private CommonsModalService: IbCModalService,
        private CommonsAncillariesService: CommonsAncillariesService) {
        this.model = this.object;
        this.$scope.$on('nextFlightNewMap', this.nextFlight);
        this.$scope.$on('newSeatChange', this.updatePassengerSeat);
        this.$scope.$on('selectPassenger', this.selectPassenger);
        this.$scope.$on('updateNewSeatMap', this.updateNewSeatMap);
        this.$scope.$on('deleteSeatSelection', this.deleteSeatSelection);
        this.$scope.$on('closeNewSeatsMap', this.closeSeatMapModal);
        this.$scope.$on('closeReductedMovilityBanner', this.closeReductedMovilityBanner);
    }

    $onInit (): void {
        this.flowName = this.$rootScope.flowName;
        this.isMobile = this.AncillariesUtilsService.isResolutionToMobile();
        this.reductedMovilityBanner = this.SeatsMapTransformer.showReductedMovilityBanner();
        this.isOldConfig = this.localStorageService.get('oldSeatsConfig');
        this.setAnaliticsInfo();
        this.initRenacen3dScript();
        this.initSegmentsInfo();
        this.getTotalSeatsPrice();

    }

    $onDestroy (): void {
        this.totalSeatsPriceSubscription.unsubscribe();
        this.seatAviosSubscription.unsubscribe();
    }

    private getTotalSeatsPrice (): void {
        this.totalSeatsPriceSubscription = this.NewSeatsMapService.totalSeatsPrice.subscribe((totalSeatsPrice: any) => {
            this.totalSeatsPrice = totalSeatsPrice;

            if (this.totalSeatsPrice.total && this.totalSeatsPrice.total !== 0) {
                this.totalSeatsPrice.total = parseInt(this.totalSeatsPrice.total.toFixed(2));
                this.totalSeatsPrice.totalFormatted = this.CurrencyService.formatPrice(this.localStorageService.get('currency'), this.totalSeatsPrice.total, true, false, false);
            }
            //show avios
            this.showModalAvios = totalSeatsPrice.total > 0 && this.AncillariesUtilsService.validatedFlightAviosInfo();
        });
    }

    private updateSlicesInfoWithSelection (): void {
        this.currentSeatmapData = this.NewSeatsMapService.getCurrentSeatmapData() ? this.NewSeatsMapService.getCurrentSeatmapData() : this.localStorageService.get('currentSeatmapData');

        if(this.currentSeatmapData && this.currentSeatmapData !== null) {
            this.model.slicesInfo.forEach((slice: any) => {
                slice.segments.forEach((segment: any) => {
                    if(this.currentSeatmapData[segment.segmentInfo.id]) {
                        segment.passengersInfo.forEach((passenger: any) => {
                            if(this.currentSeatmapData[segment.segmentInfo.id][passenger.id]
                                && !this.currentSeatmapData[segment.segmentInfo.id][passenger.id].isDeletedFromMobile) {
                                passenger.currentSeat.row = this.currentSeatmapData[segment.segmentInfo.id][passenger.id].seat.row;
                                passenger.currentSeat.column = this.currentSeatmapData[segment.segmentInfo.id][passenger.id].seat.column;
                                passenger.seatPrice = this.currentSeatmapData[segment.segmentInfo.id][passenger.id].price;
                            }
                        });
                    }
                });
            });
        }
    }


    private updateFlightMap (): void {

        this.model.seatMapInfo.passengersInfo.forEach((passenger: any) => {

            if( passenger.initialSeat
                &&( passenger.initialSeat.row !== passenger.currentSeat.row
                || passenger.initialSeat.column !== passenger.currentSeat.column)
            ) {
                const cabinIndex = passenger.initialSeat.cabinIndex;
                const rowIndex = passenger.initialSeat.rowIndex;
                const columnIndex = passenger.initialSeat.columnIndex;

                this.model.seatMapInfo.flightMap.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].occupation =
                this.AncillariesConstants.SEAT_OCCUPATIONS.free;
            }

            if(passenger.currentSeat && passenger.currentSeat.column !== '') {
                const cabinIndex = passenger.currentSeat.cabinIndex;
                const rowIndex = passenger.currentSeat.rowIndex;
                const columnIndex = passenger.currentSeat.columnIndex;

                this.model.seatMapInfo.flightMap.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].occupation =
                passenger.id === this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].id ?
                    this.AncillariesConstants.SEAT_OCCUPATIONS.selection
                    : this.AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser;
            }
        });
    }

    private initSegmentsInfo (): void {
        this.availableSegments = this.localStorageService.get('seatsAvailableSegments');
        this.singleSegment = this.availableSegments.length === 1;
        this.initSeatAvios();

        this.isSelectedSegmentFromMobileSummary = this.NewSeatsMapService.getIsSelectedSegmentFromMobileSummary();
        this.NewSeatsMapService.setIsSelectedSegmentFromMobileSummary(undefined);

        if(this.isMobile && this.isSelectedSegmentFromMobileSummary) {
            this.model.slicesInfo = this.NewSeatsMapService.getSlicesSeatmapInfo();
            if(this.model.slicesInfo) {
                this.activate();
                this.updateSlicesInfoWithSelection();
            }
        } else if(this.isMobile && this.checkShowSummary(true)) {
            this.openMobileSummarySeat();
        } else {
            this.loadSeatsModel();
        }
        if (this.isMobile) {
            this.model.slicesInfo = this.model.slicesInfo ? this.model.slicesInfo : this.NewSeatsMapService.getSlicesSeatmapInfo();
        }
    }

    private initSeatAvios (): void {
        this.seatAviosSubscription = this.NewSeatsMapService.aviosAncillariesSeats.subscribe((seatAvios: any[]) => {
            this.seatAvios = seatAvios;
        });
        this.NewSeatsMapService.setSeatAvios(this.seatAvios.length > 0 ? this.seatAvios : (this.localStorageService.get('genAviosAncillariesSeat') || []));

    }

    private checkShowSummary (showSummaryMobile: boolean): boolean {
        let showSummary = false;
        switch(this.flowName) {
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    showSummary = showSummaryMobile ? this.checkExistingSeatsBKI(showSummary) : showSummaryMobile;
                    break;
                default:
                    showSummary = showSummaryMobile ? this.checkExistingSeats(showSummary) : showSummaryMobile;
        }
        return showSummary;
    }

    private checkExistingSeatsBKI (showSummary: boolean): boolean {
        const seatConfirmationInfo = this.localStorageService.get('seatsSelectedInfoData');

        if (seatConfirmationInfo && seatConfirmationInfo !== null) {
            showSummary = true;
        }
        return showSummary;
    }
    private checkExistingSeats (showSummary: boolean): boolean {
        const issuedInfo: any = this.CommonsSessionStorageService.get('breakdownInfo')
            ? this.CommonsSessionStorageService.get('breakdownInfo') : this.CommonsSessionStorageService.get('summaryInfo'); // MMB or CKI
        const seats = issuedInfo?.issuedItems.find((ancillary: any) => ancillary.type === this.AncillariesConstants.TYPE_ANCILLARIE.SEAT);
        const freeSeats = issuedInfo?.freeItems.find((ancillary: any) => ancillary.type === this.AncillariesConstants.TYPE_ANCILLARIE.SEAT);
        const currentSeatmapData = this.CommonsSessionStorageService.get('currentSeatmapData');

        if (seats || freeSeats || currentSeatmapData) {
            showSummary = true;
        }
        return showSummary;
    }

    private openMobileSummarySeat () {
        this.ModalServiceAncillaries.openNewSummarySeatMapModal({
            currency: this.model.seatMapInfo.currency,
            availableSegments: this.availableSegments,
            isSelectedSegmentFromMobileSummary: this.isSelectedSegmentFromMobileSummary
        }).result.then((dismissModal: boolean) => {
            if(dismissModal) {
                this.closeSeatMapModal();
            }
        }, () => {});
        this.closeSeatMapModal();
    }

    activate = (): void => {
        const selectedSegment = this.getSelectedSegment(this.localStorageService.get('seatMapSegment'));
        this.localStorageService.set('aircraftCode', selectedSegment.segmentInfo.companyCode + '/' + selectedSegment.segmentInfo.aircraft.code);
        this.setSegmentData(selectedSegment);
        this.updateFlightMap();
        this.checkTour3d(selectedSegment);
        this.NewSeatsMapService.calculateTotalSeatPrice(this.model.slicesInfo, this.currency);
        this.isLoading = false;

        this.$timeout(() => {
            const dynamicPricingSeat: string = (this.model?.pricesProvider === 'IBDP') ? this.DatalayerConstants.DATALAYER_VALUES.YES : this.DatalayerConstants.DATALAYER_VALUES.NO;
            /* INIT DELETE GA4 MIGRATION */
            const confirmationDatalayerInfo = this.localStorageService.get('confirmationDatalayerInfo') || {};

            confirmationDatalayerInfo[this.DatalayerConstants.DATALAYER_INFO.DYNAMIC_PRICING_SEAT] = dynamicPricingSeat;
            this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT, confirmationDatalayerInfo, this.localStorageService.get('userLogged'));
            this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);

            /* FINISH DELETE GA4 MIGRATION*/
            const confirmationDigitalInfo = this.localStorageService.get('confirmationDigitalInfo') || {};
            confirmationDigitalInfo[this.DatalayerBKIConstants.DYNAMIC_PRICING_SEAT] = dynamicPricingSeat;
            this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT, confirmationDigitalInfo, this.localStorageService.get('userLogged'));
            this.DatalayerUtilsService.updateDatalayerViewEvent();
            this.DatalayerUtils.getAncillariesDigitalDataEcommerce('seat', this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
            this.AncillariesUtilsService.isBookingFlow() ? this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT) :this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, null, this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT);
            this.$scope.$broadcast('scrollToSeat');
            this.$scope.$broadcast('reloadInitialStatus');
            this.isLoading = false;
            this.model.isLoaded = true;
        });

        if (this.localStorageService.get('deepLinkData')) {
            this.updateDalayerInfo(this.AncillariesConstants.QUADRIGAM.MODAL_SELECT_SEAT_DEEPLINK);
        }

        this.DatalayerUtils.setRemoveSeatSelectedId();
    };

    /**
     * This functions update datalayerInfo. The quadrigam change according to flow.
     * @param {String} quadrigam value to update datalayer_general.
     * @returns {Void}
     *  */
    updateDalayerInfo = (quadrigam): void => {
        const confirmationDatalayerInfo = this.localStorageService.get('confirmationDatalayerInfo');
        const confirmationDigitalInfo = this.localStorageService.get('confirmationDigitalInfo') || {};
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(
            quadrigam,
            confirmationDatalayerInfo,
            this.AncillariesUtilsService.isUserLogged()
        );
        /* FINISH DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(
            quadrigam,
            confirmationDigitalInfo,
            this.AncillariesUtilsService.isUserLogged()
        );
        this.DatalayerUtilsService.sendDatalayerEvent('view');
        this.$rootScope.$broadcast('updateDatalayer');
    };



    private checkTour3d (selectedSegment: any) {
        this.showTour = false;
        let haveLayout: boolean;
        let cabinToShow: string;
        let cabinLayout: string;
        let isUnavailable: boolean = false;
        const aircraftCode: string = selectedSegment.segmentInfo.aircraft.code;
        selectedSegment.flightMap.cabins.forEach(cabin => {
            if((cabin.cabinClass.type === selectedSegment.segmentInfo.cabinClassType) && cabin.layoutSeat3D) {
                haveLayout = true;
                cabinToShow = cabin.cabinClass.type;
                cabinLayout = cabin.layoutSeat3D;
            }
        });
        if (this.flowName === this.AncillariesConstants.APPLICATION_FLOW.CHECKIN && aircraftCode === '332') {
            isUnavailable = true;
        }
        if(selectedSegment.flightMap.layoutTour3D && !isUnavailable) {
            this.aircraftToShow = selectedSegment.flightMap.layoutTour3D;
            this.showTour = true;
            this.seatViewInfo = true;
            this.init3dTour(this.showTour, cabinToShow);
            this.seatViewInfo = this.getSeat3dViewAdditionalInfo(selectedSegment, cabinLayout);
        } else if (cabinLayout && !isUnavailable) {
            this.init3dTour(this.showTour, cabinToShow);
            this.seatViewInfo = this.getSeat3dViewAdditionalInfo(selectedSegment, cabinLayout);
        }
    }

    private setSegmentData (data: any) {
        this.model.seatMapInfo.segmentInfo = data.segmentInfo;
        this.model.seatMapInfo.columnsInfo = data.columnsInfo;
        this.model.seatMapInfo.passengersInfo = data.passengersInfo;
        this.model.seatMapInfo.currentPassengerIndex = 0;
        this.model.seatMapInfo.flightMap = data.flightMap;
        this.model.seatMapInfo.flightMap.layoutTour3D = data.layoutTour3D;
        this.model.seatMapInfo.legendInformation = data.legend;
        this.model.seatMapInfo.totalPrice = data.totalPrice;
        this.model.seatMapInfo.currency = data.currency;
        this.model.isFirstSegment = data.isFirstSegment;
        this.model.isLastSegment = this.setIsLastSegment();
        this.model.pricesProvider = data.pricesProvider;
        this.model.isCurrencyLong = this.AncillariesUtilsService.isCurrencyLong(this.model.seatMapInfo.currency.code);
        this.localStorageService.set('addEarlyChecking', this.AncillariesUtilsService.addEarlyChecking(data, this.localStorageService.get('addEarlyChecking')));
        this.currency = data.currency;
        this.updateData = [];
        this.model.seatMapInformation = this.CommonsSessionStorageService.get('seatMap');
        this.model.orderData = this.CommonsSessionStorageService.get('createOrderData');
        if(!this.model.seatMapInfo.segmentInfo.date.day) {
            this.model.seatMapInfo.segmentInfo.date.day = data.segmentInfo.date.monthDay;
            if(this.model.seatMapInfo.segmentInfo.date.day < 10) {
                this.model.seatMapInfo.segmentInfo.date.day = '0' + this.model.seatMapInfo.segmentInfo.date.day;
            }
        }
        let longHaulTypes = this.AncillariesConstants.LONG_HAUL_AIRCRAFTS;
        if (this.localStorageService.get('longHaulAircrafts')) {
            longHaulTypes = this.localStorageService.get('longHaulAircrafts');
        }
        if (longHaulTypes[this.model.seatMapInfo.segmentInfo.companyCode]?.includes(this.model.seatMapInfo.segmentInfo.aircraft.code)) {
            this.model.seatMapInfo.segmentInfo.isLongHaul = true;
        }
    }

    private setIsLastSegment (): boolean {
        this.isLastSegment = false;
        const segmentSeat: any = this.localStorageService.get('seatsAvailableSegments');
        let availableSegments: any = this.localStorageService.get('ancillariesAvailableSegments');
        const actualSegmenId: any = this.localStorageService.get('seatMapSegment');
        let i = 0,
            isFound = false;

        availableSegments = segmentSeat ? segmentSeat : availableSegments;
        while (!isFound && i < availableSegments.length) {
            if (actualSegmenId.segmentId.toString() === availableSegments[i].toString()) {
                isFound = true;
                if (i + 1 === availableSegments.length) {
                    this.isLastSegment = true;
                    this.model.isLoaded = false;
                }
            }
            !this.isLastSegment ? (this.nextSegment = availableSegments[i + 1]) : angular.noop;
            i++;
        }


        return this.isLastSegment;
    }

    private init3dTour (aircraftIsValid: boolean, cabinToShow: string) {
        if (this.$window.SeatMapVr) {
            this.$window.SeatMapVr.config({
                cdnPath: 'https://iberia.3dseatmapvr.com'
            });
            this.$window.SeatMapVr.init();
            if (aircraftIsValid) {
                this.$window.SeatMapVr.selectScene({
                    layout: this.aircraftToShow,
                    scene: cabinToShow,
                    thumbnail: this.$window.SeatMapVr.THUMBNAIL ? this.$window.SeatMapVr.THUMBNAIL.ANIMATED_PREVIEW : 3,
                    elSelector: '.seatmap3Dview',
                    screenMode: this.$window.SeatMapVr.SCREEN_MODE ? this.$window.SeatMapVr.SCREEN_MODE.MODAL: 1
                });
            }
        }
    }

    private setAnaliticsInfo () {
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries('elegir equipaje', 'click', 'anadir');
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.CommonsConstants.QUADRIGAM.MODAL_SELECT_SEAT, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.AncillariesUtilsService.isMMBFlow() && this.CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_CUSTOMIZE_YOU_FLIGHT');
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updateDigitalData');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
    }

    private initRenacen3dScript () {
        if (!this.$window.SeatMapVr) {
            this.NewSeatsMapService.initRenacen3dScript();
        }
    }

    getSeat3dViewAdditionalInfo (selectedSegment: any, cabinLayout: string): any {
        const seatViewInfo: any = {};

        seatViewInfo.layout = cabinLayout;
        seatViewInfo.seat = {
            displayCabinClass: selectedSegment.segmentInfo.cabinClassDescription
        };
        seatViewInfo.flight = {
            displayflight: selectedSegment.segmentInfo.aircraft.description,
            origin: selectedSegment.segmentInfo.departure.code,
            destination: selectedSegment.segmentInfo.arrival.code
        };

        return seatViewInfo;
    }

    /**
     *  Exit of seat map and prevoius check conditions:
     *  1 - Early flow
     *     - Is obligatory and it´s necessary select a set for continue flow
     *     - Check if all passenger have a seat and we show modal window for advise user it´s necessary select seat for all passengers
     *  2- In flows different of early if user change the seat and try close the seat map we show the confirmation modal for advise the user
     *
     */
    cancelSeatMap (): any {
        this.NewSeatsMapService.cancelSeatMap().then((dismissModal: boolean) => {
            if(dismissModal) {
                this.dismissModal();
            }
        });
    }

    /**
     * Dismiss seat map modal
     */
    dismissModal = (): void => {
        angular.element(this.$window).unbind('click');
        if(this.$window.SeatMapVr) {
            this.$window.SeatMapVr.destroy();
        }
        this.isLoadingConfirmSeats = false;
        this.isLoading = false;
        this.$uibModalInstance.dismiss();
    };

    /**
     * Close seat map modal window
     */
    closeSeatMapModal = (): void => {
        this.updateDatalayerInfo();
        this.isLoadingConfirmSeats = false;
        this.isLoading = false;
        this.$uibModalInstance.close();
    };

    private updateDatalayerInfo (): void {
        const flow = this.localStorageService.get('flowApp');
        this.loadSegmentsToCart();
        this.DatalayerUtils.setSeatAddToCart(this.model.cartSegments);
        this.$rootScope.$broadcast('acceptSeats');
        this.$uibModalInstance.close();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        this.$window.DigitalChange('link', this.$window.datalayer_general, this.$window.datalayer_ecommerce);
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    }

    private loadSegmentsToCart = (): void => {
        this.model.cartSegments = {
            seatInfo: {
                isCurrencyLong: this.model.isCurrencyLong,
                segments: [],
                totalPrice: 0,
                totalPriceFormatted: '0€'
            }
        };
        let totalPrice = 0;
        this.model.slicesInfo?.forEach(slices => {
            slices.segments.forEach(segment => {
                const segmentInfo = {
                    arrival: segment.segmentInfo.arrival,
                    departure: segment.segmentInfo.departure,
                    id: segment.segmentInfo.id,
                    passengers: segment.passengersInfo
                };
                segment.passengersInfo.forEach(pass => {
                    totalPrice += pass.seatPrice;
                });
                this.model.cartSegments.seatInfo.segments.push(segmentInfo);
            });
        });
        this.model.cartSegments.seatInfo.totalPrice = totalPrice;
        this.model.cartSegments.seatInfo.totalPriceFormatted = this.CurrencyService.formatPrice(this.currency, totalPrice, false, false, false);
    };

    private updateDataLayerAndDigitalData (): void  {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
    }

    /**
     * Scroll to passenger when is selected in scroll list component
     * @param {*} evt
     * @param {*} idPassenger
     */
    selectPassenger = (evt, idPassenger): void => {
        let i;
        if (this.AncillariesUtilsService.isCheckinFlow()) {
            this.model.seatMapInfo.currentPassengerIndex = idPassenger - 1;
        } else {

            for (i = 0; i < this.model.seatMapInfo.passengersInfo.length; i++) {
                if (this.model.seatMapInfo.passengersInfo[i].id === idPassenger) {
                    this.model.seatMapInfo.currentPassengerIndex = i;
                }
            }
        }
        this.changePassenger(idPassenger);
        this.$rootScope.$broadcast('updateCabinZones');
        this.$window.DigitalChange('link', this.$window.datalayer_general, this.$window.datalayer_ecommerce);
    };

    /**
     * Change passenger seat and update info of seats updated
     * @param {*} event
     * @param {Object} seatData Information of seat selected to update
     */
    updatePassengerSeat = (event, seatData): void => {

        // aqui es donde se actuliza el precio total asientos
        this.model.totalPrice = this.NewSeatsMapService.calculateTotalSeatPrice(this.model.slicesInfo, this.currency);
        // aqui se actualiza el completeData
        this.updateCurrentSeatmapData(seatData);

        // aqui generamos el transformer del asiento
        this.NewSeatsMapService.setSeatAvios(this.SeatsMapTransformer.genAviosSeatReq(this.seatAvios, seatData, this.model.seatMapInfo.segmentInfo.id));

        // se cambia al siguiente pasajero
        if(this.model.seatMapInfo.passengersInfo.map(passenger =>  passenger.id).indexOf(seatData.id) < this.model.seatMapInfo.passengersInfo.length -1) {
            this.selectPassenger(undefined, this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex + 1].id);
        // se cambia al siguiente vuelo
        } else {
            if (!this.isMobile) {
                const lastSlice = this.model.slicesInfo[this.model.slicesInfo.length - 1];
                const lastSegmentId = lastSlice.segments[lastSlice.segments.length - 1].segmentInfo.id.toString();
                if (this.seatmapSegment.segmentId.toString() !== lastSegmentId.toString()) {
                    this.nextFlight();
                }
            }
        }

        this.DatalayerUtils.setSeatSelectItem(this.model, seatData);

        this.$rootScope.$broadcast('updateCabinZones');
    };

    updateCurrentSeatmapData (seatData: any): void {
        const segmentInfo: any= this.localStorageService.get('seatMapSegment');
        if(!this.currentSeatmapData) {
            this.currentSeatmapData = this.NewSeatsMapService.getCurrentSeatmapData() ? this.NewSeatsMapService.getCurrentSeatmapData() : {};
        }

        if(this.currentSeatmapData && this.currentSeatmapData[segmentInfo.segmentId]) {
            this.updatePassengerCurrentSeatmapData(segmentInfo, seatData);
        } else {
            this.currentSeatmapData[segmentInfo.segmentId] = {};
            this.updatePassengerCurrentSeatmapData(segmentInfo, seatData);
        }

        this.NewSeatsMapService.setIsAnySeatUpdated(true);
        this.NewSeatsMapService.setCurrentSeatmapData(this.currentSeatmapData);

    }

    private updatePassengerCurrentSeatmapData (segmentInfo: any, seatData: any): void {
        this.currentSeatmapData[segmentInfo.segmentId][seatData.id] = {
            id: seatData.id,
            originalType: seatData.originalType,
            price: seatData.price,
            priceFormatted: seatData.priceFormatted,
            seat: {
                row: seatData.seat.row,
                column: seatData.seat.column,
                cabinIndex: seatData.seat.cabinIndex,
                rowIndex: seatData.seat.rowIndex,
                columnIndex: seatData.seat.columnIndex
            },
            seatType: seatData.seatType,
            seatTypeDescription: seatData.seatTypeDescription,
            passengerInfo: this.model.seatMapInfo.passengersInfo.find((passenger: any) => passenger.id === seatData.id)
        };

        // Avoid DELETE request if passanger already selected a seat
        this.checkDeleteSeatIfAlreadySelected(segmentInfo, seatData);

    }

    private checkDeleteSeatIfAlreadySelected (segmentInfo: any, seatData: any): void {
        this.deleteCurrentSeatmapData.forEach((ancillarySeat: any) => {
            ancillarySeat.segments.forEach((segment: any) => {
                if (segment.id === segmentInfo.segmentId) {
                    segment.passengers = segment.passengers.filter((passengerId: string) => passengerId !== seatData.id);
                }
            });
        });
        this.deleteCurrentSeatmapData = this.deleteCurrentSeatmapData
            .filter((ancillarySeat: any) => ancillarySeat.segments
                .find((segment: any) => segment.passengers.length > 0
                && segment.passengers.find((passengerId: string) => passengerId !== seatData.id))
            );
        this.NewSeatsMapService.setDeleteCurrentSeatmapData(this.deleteCurrentSeatmapData);
    }

    deleteSeatSelection = (event: any, passengerId: string): void => {
        const segmentInfo: any= this.localStorageService.get('seatMapSegment');
        this.deleteCurrentSeatmapData = this.isMobile ?
            this.NewSeatsMapService.getDeleteCurrentSeatmapData() : this.deleteCurrentSeatmapData;
        if(this.currentSeatmapData[segmentInfo.segmentId][passengerId]
            && !this.currentSeatmapData[segmentInfo.segmentId][passengerId].isPreBooked) {
            delete this.currentSeatmapData[segmentInfo.segmentId][passengerId];

        } else if (this.currentSeatmapData[segmentInfo.segmentId][passengerId]) {
            const segment: any = {
                id: segmentInfo.segmentId,
                passengers: [passengerId]
            };
            if(this.deleteCurrentSeatmapData.length > 0) {
                const currentSegment = this.deleteCurrentSeatmapData[0].segments
                    .find((segment: any ) => segment.id === segmentInfo.segmentId);
                currentSegment ?
                    currentSegment.passengers.push(passengerId) : this.deleteCurrentSeatmapData[0].segments.push(segment);
            } else {
                this.deleteCurrentSeatmapData.push({
                    segments: [segment],
                    type: this.AncillariesConstants.TYPE_ANCILLARIE.SEAT
                });
            }

            if(this.isMobile) {
                this.currentSeatmapData[segmentInfo.segmentId][passengerId].isDeletedFromMobile = true;
            }
        }

        if(Object.keys(this.currentSeatmapData[segmentInfo.segmentId]).length === 0) {
            delete this.currentSeatmapData[segmentInfo.segmentId];
        }

        if (Object.keys(this.currentSeatmapData).length === 0 ) {
            this.currentSeatmapData = undefined;
        }

        this.NewSeatsMapService.setCurrentSeatmapData(this.currentSeatmapData);
        this.NewSeatsMapService.setDeleteCurrentSeatmapData(this.deleteCurrentSeatmapData);
        this.NewSeatsMapService.calculateTotalSeatPrice(this.model.slicesInfo, this.currency);


        this.NewSeatsMapService.setSeatAvios(this.SeatsMapTransformer.deleteAviosUnselectedSeat(segmentInfo.segmentId, passengerId));

    };

    /**
     * Return the initial seat of passenger in text
     */
    getInitialPassengerSeat = (): any => {
        return this.model.seatMapInfo.passengersInfo && this.model.seatMapInfo.passengersInfo.length > 0
            ? this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].initialSeat.row +
                this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].initialSeat.column
            : '';
    };

    /**
     * Return the current seat of passenger in text
     */
    getCurrentPassengerSeat = (): any => {
        return this.model.seatMapInfo.passengersInfo && this.model.seatMapInfo.passengersInfo.length > 0
            ? this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].currentSeat.row +
                    this.model.seatMapInfo.passengersInfo[this.model.seatMapInfo.currentPassengerIndex].currentSeat.column
            : '';
    };

    /**
     * Update map for show current passenger in seat
     * Check if the next passenger have seat for scroll to that,if not have seat then not make scroll and stay
     * in same position of seat map
     * @param {Integer} idPassenger Id of passenger
     */
    changePassenger = (idPassenger: string): void => {
        for (let i = 0; i < this.model.seatMapInfo.passengersInfo.length; i++) {
            const cabinIndex = this.model.seatMapInfo.passengersInfo[i].currentSeat.cabinIndex;
            const rowIndex = this.model.seatMapInfo.passengersInfo[i].currentSeat.rowIndex;
            const columnIndex = this.model.seatMapInfo.passengersInfo[i].currentSeat.columnIndex;
            if (
                this.model.seatMapInfo.passengersInfo[i].currentSeat.row !== '' &&
                this.model.seatMapInfo.passengersInfo[i].currentSeat.column !== ''
            ) {
                this.model.seatMapInfo.flightMap.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].occupation =
                    this.model.seatMapInfo.passengersInfo[i].id === idPassenger
                        ? this.AncillariesConstants.SEAT_OCCUPATIONS.selection
                        : this.AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser;
            }
        }
        this.$window.DigitalChange('link', this.$window.datalayer_general, this.$window.datalayer_ecommerce);
    };


    nextFlight = (): void => {
        const isLastSegment = this.isSelectedSegmentFromMobileSummary || this.isLastSegment;
        this.backPassengerUpdate = false;
        this.model.isLoaded = true;
        this.isLoading = true;
        this.NewSeatsMapService.setSegmentSelected(this.nextSegment);
        this.updateSeatMap(isLastSegment, this.nextSegment);
    };


    /**
     * Check-in [If it´s early check-in and all passengers don´t have seats, show modal]
     * Booking []
     * @param {boolean} isLastSegment True if is the last segment of segments selected
     * @param {Object} nextSegment Information of next segment to load
     */
    updateSeatMap = (isLastSegment: any, nextSegment: any): void => {

        if (isLastSegment && this.isMobile) {
            this.ModalServiceAncillaries.openNewSummarySeatMapModal({
                currency: this.model.seatMapInfo.currency,
                isSelectedSegmentFromMobileSummary: this.isSelectedSegmentFromMobileSummary
            }).result.then((closeSeatmap: boolean) => {
                if(closeSeatmap) {
                    this.closeSeatMapModal();
                }
            }, () => {});
        } else if (isLastSegment) {
            this.closeSeatMapModal();
        } else if (!isLastSegment) {
            this.setSegmentInfo(nextSegment);
            this.activate();
        }
    };

    /**
     * Show error modal with error returned for service
     * @param {Object} errorUpdate
     */
    updateSeatMapError = (errorUpdate): void => {
        this.NewSeatsMapService.setCurrentSeatmapData(undefined);
        const modalErrorObject = {
            title: 'NEW_SEATS_MAP_GENERIC_ERROR_TITLE',
            body: 'NEW_SEATS_MAP_GENERIC_ERROR_DESCRIPTION'
        };
        this.CommonsModalService.showGenericError(null, modalErrorObject);
        this.dismissModal();
    };


    confirmSelectedSeats (): void {
        const unselectedSegments: boolean = this.NewSeatsMapService.getIfUnselectedSegments();
        if (this.localStorageService.get('earlyCheckinCode') && unselectedSegments) {
            this.NewSeatsMapService.showModalEarlyCKI();
        } else {
            this.updateSelectedSeats();
        }
    }

    private updateSelectedSeats (): void {
        this.isLoadingConfirmSeats = true;
        this.isLoading = true;
        this.NewSeatsMapService.confirmSelectedSeats().then(() => {
            this.closeSeatMapModal();
        },
        () => {
            this.dismissModal();
        });
    }

    /**
     * Check if actual passenger is the last of segment
     * @returns BOOL
     */
    isLastPassenger = (): any => {
        return this.model.seatMapInfo.currentPassengerIndex === this.model.seatMapInfo.passengersInfo.length - 1;
    };

    /**
     * Check if one passenge or more not have seat assigned
     * @return BOOL True if one passenger or more not have seat | FALSE if all passengers have seat assigned
     */
    showUpdateModalEarly = (): any => {
        let isPending = false;

        angular.forEach(this.model.seatMapInfo.passengersInfo, (pass) => {
            if (pass.currentSeat.row === '' && pass.currentSeat.column === '') {
                isPending = true;
            }
        });
        return isPending;
    };

    /**
     * Set in localStorage informaton of segment to open seat map
     * @param {Integer} segmentId
     */
    setSegmentInfo = (segmentId): void => {
        if (
            this.AncillariesUtilsService.isCheckinFlow() ||
            this.$rootScope.flowName === this.AncillariesConstants.APPLICATION_FLOW.BOOKING
        ) {
            this.AncillariesUtilsService.setSegmentInfo({
                segmentId: segmentId,
                pasId: this.localStorageService.get('passengersSelected')[0]
            });
        } else {
            this.AncillariesUtilsService.setSegmentInfo({
                segmentId: segmentId,
                pasId: this.localStorageService.get('ancillariesAvailablePassengers')[0]
            });
        }
    };

    /*
    ** open modal avios
    */
    openModalAviosSeatAncillaries = (): void => {
        this.NewSeatsMapService.openModalAviosSeatAncillaries(this.seatAvios);
    };

    /*
    ** Get id from new seats map
    */
    updateNewSeatMap = (evd, lastSegment, segmentId) => {
        this.updateSeatMap(lastSegment, segmentId);
    };

    loadSeatsModel (): any  {
        this.NewSeatsMapService.loadSeatmapSegments().then((slices: any) => {
            this.model.slicesInfo = slices;
            this.activate();
            this.updateSlicesInfoWithSelection();
            this.NewSeatsMapService.calculateTotalSeatPrice(this.model.slicesInfo, this.currency);
        }).catch((error: any) => {
            this.dismissModal();
            throw new Error(error.message);
        });
    }


    getSelectedSegment (selectedSegment: any): any {
        this.seatmapSegment = selectedSegment;
        return this.model.slicesInfo.find((slice: any)=>
            slice.segments.find((segment: any) =>
                segment.segmentInfo.id.toString() === selectedSegment.segmentId.toString()))
            .segments.find((segment: any) => segment.segmentInfo.id.toString() === selectedSegment.segmentId.toString());
    }

    backToMain = () => {
        this.NewSeatsMapService.backToMain(true);
    };

    closeReductedMovilityBanner = () => {
        this.reductedMovilityBanner = false;
    };
}

try {
    NewSeatsMapController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(NewSeatsMapController.name, NewSeatsMapController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    NewSeatsMapController.$inject = controllerInfo.inject;
    mod.controller(NewSeatsMapController.name, NewSeatsMapController);
}
